"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsecureTokenProvider = void 0;
const protocol_definitions_1 = require("@fluidframework/protocol-definitions");
const generateToken_1 = require("./generateToken");
/**
 * Provides an in memory implementation of {@link @fluidframework/routerlicious-driver#ITokenProvider} that can be
 * used to insecurely connect to the Fluid Relay.
 *
 * As the name implies, this is not secure and should not be used in production.
 * It simply makes examples where authentication is not relevant easier to bootstrap.
 */
class InsecureTokenProvider {
    constructor(
    /**
     * Private server tenantKey for generating tokens.
     */
    tenantKey, 
    /**
     * User with whom generated tokens will be associated.
     */
    user, 
    /**
     * Optional. Override of scopes. If a param is not provided, InsecureTokenProvider
     * will use the default scopes which are document read, write and summarizer write.
     *
     * @param scopes - See {@link @fluidframework/protocol-definitions#ITokenClaims.scopes}
     *
     * @defaultValue - [ ScopeType.DocRead, ScopeType.DocWrite, ScopeType.SummaryWrite ]
     */
    scopes) {
        this.tenantKey = tenantKey;
        this.user = user;
        this.scopes = scopes;
    }
    /**
     * {@inheritDoc @fluidframework/routerlicious-driver#ITokenProvider.fetchOrdererToken}
     */
    async fetchOrdererToken(tenantId, documentId) {
        var _a;
        return {
            fromCache: true,
            jwt: (0, generateToken_1.generateToken)(tenantId, this.tenantKey, (_a = this.scopes) !== null && _a !== void 0 ? _a : [
                protocol_definitions_1.ScopeType.DocRead,
                protocol_definitions_1.ScopeType.DocWrite,
                protocol_definitions_1.ScopeType.SummaryWrite,
            ], documentId, this.user),
        };
    }
    /**
     * {@inheritDoc @fluidframework/routerlicious-driver#ITokenProvider.fetchStorageToken}
     */
    async fetchStorageToken(tenantId, documentId) {
        var _a;
        return {
            fromCache: true,
            jwt: (0, generateToken_1.generateToken)(tenantId, this.tenantKey, (_a = this.scopes) !== null && _a !== void 0 ? _a : [
                protocol_definitions_1.ScopeType.DocRead,
                protocol_definitions_1.ScopeType.DocWrite,
                protocol_definitions_1.ScopeType.SummaryWrite,
            ], documentId, this.user),
        };
    }
}
exports.InsecureTokenProvider = InsecureTokenProvider;
//# sourceMappingURL=insecureTokenProvider.js.map